/* import __COLOCATED_TEMPLATE__ from './company-profile-summary.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { enqueueTaskGroup, task } from 'ember-concurrency';

const CLASS_NAME = 'SH-c-company-profile-summary';

const cloneCompany = (company) => ({
  slug: company.slug,
});

class CompanyProfileSummaryComponent extends Component {
  @service('state-managers/application')
  applicationStateManager;

  @enqueueTaskGroup
  updateCompany;

  element = null;

  get className() {
    return CLASS_NAME;
  }

  @action
  onInsert(element) {
    this.element = element;
  }

  @action
  onClick(e) {
    e.target.blur();
    this.element.click();
  }

  @task({ group: 'updateCompany' })
  *uploadImage(e) {
    const { company } = this.args;

    const [file] = e.target.files;
    e.target.value = '';

    try {
      const draftImage = yield this.args.uploadCompanyImage(file);

      yield this.args.saveCompanySettings({
        ...cloneCompany(company),
        image_cloud_id: draftImage.cloudId,
        image_cloud_version: draftImage.cloudVersion,
      });
    } catch {
      this.applicationStateManager.addToast('Failed to save image');
    }
  }

  @task({ group: 'updateCompany' })
  *save(field, value) {
    const { company } = this.args;

    try {
      yield this.args.saveCompanySettings({ ...cloneCompany(company), [field]: value });
    } catch {
      this.applicationStateManager.addToast('Failed to save company settings');
    }
  }
}

export default CompanyProfileSummaryComponent;
